import { render } from "./GenerateQRCode.vue?vue&type=template&id=3d4870ac&scoped=true"
import script from "./GenerateQRCode.vue?vue&type=script&lang=js"
export * from "./GenerateQRCode.vue?vue&type=script&lang=js"

import "./GenerateQRCode.vue?vue&type=style&index=0&id=3d4870ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4870ac"]])

export default __exports__